<template>
  <div class="park-detail">
    <div class="park-detail-base">
      <div class="park-detail-base-img">
        <div class="swiper mySwiper2">
          <div class="swiper-wrapper">
            <el-image
              v-for="(item, index) in parkDetailData.pronounceImages"
              :key="index"
              :src="imgUrl + item.filePath"
              fit="cover"
              class="swiper-slide"
            ></el-image>
          </div>
        </div>
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <el-image
              v-for="(item, index) in parkDetailData.pronounceImages"
              :key="index"
              :src="imgUrl + item.filePath"
              fit="cover"
              class="swiper-slide"
            ></el-image>
          </div>
          <div class="swiper-button-prev m-swiper-button" />
          <div class="swiper-button-next m-swiper-button" />
        </div>
      </div>
      <div class="park-detail-base-content">
        <div class="park-detail-base-content-price">
          <div class="park-detail-base-content-price-text">
            {{ parkDetailData.name }}
          </div>
          <div class="park-detail-base-content-price-span">
            浏览：{{ parkDetailData.statistical }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">联系人</div>
          <div
            class="park-detail-base-content-info-value info-value-text1 info-value-bold"
          >
            {{ parkDetailData.person }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">联系方式</div>
          <div
            class="park-detail-base-content-info-value info-value-text1 info-value-bold"
          >
            {{ parkDetailData.phone }}
          </div>
        </div>
        <!-- <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">园区级别</div>
          <div class="park-detail-base-content-info-value info-value-text2">
            {{ parkDetailData.parkLevelName }}
          </div>
        </div> -->

        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">产业聚集区面积</div>
          <div class="park-detail-base-content-info-value info-value-text2">
            {{ parkDetailData.actualAreaActual }}公顷
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">
            基础设施: {{ parkDetailData.infrastructureName }} (
            {{ parkDetailData.infrastructureStr }})
          </div>
          <div
            class="park-detail-base-content-info-value info-value-text2"
          ></div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">产业类型</div>
          <div class="park-detail-base-content-info-value info-value-text3">
            {{ parkDetailData.leadingIndustry }}
          </div>
        </div>
        <div class="park-detail-base-content-info grid-single-line">
          <div class="park-detail-base-content-info-key">产业聚集位置</div>
          <div class="park-detail-base-content-info-value info-value-text3">
            {{ parkDetailData.locationActual }}
          </div>
        </div>
      </div>
    </div>
    <!--   -->
    <!-- <park-popular-push
      :park-code="parkDetailData.parkCode"
      style="margin-top: 20px"
    /> -->
    <park-popular-push
      :park-code="parkDetailData.parkCode"
      style="margin-top: 20px"
    />
    <div class="park-detail-info">
      <div class="park-detail-info-content">
        <div class="park-detail-info-content-nav">
          <div :class="['park-detail-info-content-nav-li', 'active-li']">
            招商信息
          </div>
        </div>
        <div id="investment" class="park-detail-info-investment">
          <!-- v-html="info" -->
          <div class="info-content scrollbar-definition">
            <h4>招商政策</h4>
            <span
              >红河综合保税区是全国第三家，全省第一家设立在少数民族自治地区的国家级高新区，也是省委、省人民政府重点打造的主营业务收入超千亿元园区。目前，高新区规划控制面积127平方公里（含东瓜镇、苍岭工业片区），其中：中心建成区21平方公里，工业园区60.27平方公里，形成了以烟草及其配套、冶金化工建材、生物医药、装备制造和绿色食品加工为主的产业体系，以及富民庄甸工业园、赵家湾桃园工业园和苍岭工业园的“一区三园”发展格局。</span
            >
            <h4>项目情况</h4>
            <span
              >红河综合保税区合政策的初创期小微企业、创业团队和服务企业团队、创业导师等各种创新创业要素引进孵化器，以规范管理服务为手段，聚集各类创业创新要素，开展创业孵化服务，全力加快企业科技研发及成果转化，加大科技型企业的培育力度，力争把红河综合保税区科技企业孵化器打造成为设施齐全、运行管理规范、服务功能齐全、服务业绩突出、创业创新活跃、示范带动作用强的创新创业孵化载体和平台。</span
            >
            <h4>招商需求</h4>
            <span
              >企业注册地在红河综合保税区属地范围内，办公场所应当在孵化器所属场地内；
              属新注册企业或申请进入孵化器前企业成立时间不足3年；
              企业注册资金一般不超过500万元（对注册资金有特别要求的行业不受此限）；
              属迁入的企业，上一年度营业收入一般不超过500万元；
              企业从事研究、开发、生产的项目或产品应当符合高新区产业导向；
              项目技术来源清晰，无知识产权权属纠纷；市场发展潜力大，预期的经济与社会效益显著</span
            >
            <h4>产业链</h4>
            <span
              >企业负责人熟悉本企业产品研究、开发工作，并具有良好的经营管理和市场开拓能力；
              有技术开发队伍和技术开发条件，有实施孵化项目的技术能力和后续开发能力；</span
            >
            <h4>用地情况</h4>
            <span
              >红河综合保税区是全国第三家，全省第一家设立在少数民族自治地区的国家级高新区，也是省委、省人民政府重点打造的主营业务收入超千亿元园区。目前，高新区规划控制面积127平方公里（含东瓜镇、苍岭工业片区），其中：中心建成区21平方公里，工业园区60.27平方公里，形成了以烟草及其配套、冶金化工建材、生物医药、装备制造和绿色食品加工为主的产业体系，以及富民庄甸工业园、赵家湾桃园工业园和苍岭工业园的“一区三园”发展格局。</span
            >
          </div>
          <div
            v-if="parkDetailData.pronounceVideos?.length"
            class="park-detail-info-investment-video"
          >
            <div
              v-for="(item, index) of parkDetailData.pronounceVideos"
              :key="index"
              class="park-detail-info-investment-video-item"
              @click="playVideos(item)"
            >
              <div class="park-detail-info-investment-video-item-thumbnail">
                <el-image
                  :src="imgUrl + item.thumbnail"
                  fit="cover"
                  class="park-detail-info-investment-video-item-thumbnail-img"
                />
                <el-image
                  :src="require('@/assets/images/common/视频播放.png')"
                  fit="cover"
                  class="park-detail-info-investment-video-item-thumbnail-action"
                />
              </div>
              <div class="park-detail-info-investment-video-item-title">
                {{ item.fileTitle }}
              </div>
            </div>
          </div>
          <div
            v-if="parkDetailData.pronounceImages?.length"
            class="park-detail-info-investment-image"
          >
            <div
              v-for="(item, index) of parkDetailData.pronounceImages"
              :key="index"
              class="park-detail-info-investment-image-item"
              @click="handleLook(parkDetailData.pronounceImages, index)"
            >
              <el-image
                :src="imgUrl + item.filePath"
                fit="cover"
                class="park-detail-info-investment-image-item-img"
              />
              <div class="park-detail-info-investment-image-item-title">
                {{ item.fileTitle }}
              </div>
            </div>
          </div>
          <div
            v-if="parkDetailData.attachmentFiles?.length"
            class="park-detail-info-investment-file"
          >
            <div
              class="park-detail-info-investment-file-li"
              v-for="(item, index) of parkDetailData.attachmentFiles"
              :key="index"
              @click="previewOrDownFile(item.filePath)"
            >
              <div><img :src="getFileIconUrl(item.suffix)" alt="" /></div>
              <div class="park-detail-info-investment-image-item-title">
                {{ item.fileTitle }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <park-place id="parkPlace" />
        <!-- :park-code-actual="parkDetailData.parkCodeActual"
          :park-id="parkDetailData.id" -->
      </div>

      <video-dialog
        :visible="playVideo.show"
        :videoSrc="playVideo.src"
        :videoTitle="playVideo.title"
        @onCloseVideo="playVideo.show = false"
      />
      <el-image-viewer
        v-if="previewImage.show"
        :url-list="previewImage.urlList"
        :initial-index="previewImage.index"
        :on-close="() => (previewImage.show = false)"
      />
    </div>
  </div>
</template>

<script>
import ParkPlace from "@/views/industry/components/ParkPlace";
// import ParkPopularPush from "@/views/park/components/ParkPopularPush";
import Swiper from "swiper/swiper-bundle.min";
import "swiper/swiper-bundle.min.css";
import VideoDialog from "@/components/currency/videoDialog";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { getParkDetail } from "@/api/setting/investment";
import ParkPopularPush from "@/views/industry/components/ParkPopularPush";
/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/15 16:38
 * @Description 园区详情
 */
export default {
  name: "parkDetail",
  //ParkPopularPush,
  components: { ElImageViewer, ParkPlace, VideoDialog, ParkPopularPush },
  data() {
    return {
      parkDetailData: {
        name: "高新科技产业聚集区",
        parkLevelName: "产业聚集区",
        statistical: "310",
        actualAreaActual: 1.24,
        person: "王爱国",
        phone: "13454568754",
        pronounceImages: [
          {
            filePath:
              "2022\\8\\2022-08-31\\10\\4145f0490fad440e990eee58f40b9979.png",
            fileName: "红河.png",
            suffix: "png",
            targetId: "4145f0490fad440e990eee58f40b9979",
            fileTitle: "图片1",
            thumbnail: "",
          },
        ],
      },
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
      playVideo: {
        show: false,
        src: undefined,
        title: undefined,
      },
      infrastructureConfigList: [
        {
          value: "1",
          label: "土地平整",
        },
        {
          value: "2",
          label: "通雨水管线",
        },
        {
          value: "3",
          label: "通污水管线",
        },
        {
          value: "4",
          label: "通电信管道及电缆",
        },
        {
          value: "5",
          label: " 通热力管线",
        },
        {
          value: "6",
          label: "通电力管线",
        },
        {
          value: "7",
          label: "通自来水管线",
        },
        {
          value: "8",
          label: "通天然气管线",
        },
        {
          value: "9",
          label: "通有线电视线光缆",
        },
        {
          value: "10",
          label: "通道路",
        },
      ],
      previewImage: {
        show: false,
        urlList: [],
        index: 0,
      },
      info: `
      <h4>招商政策</h4><span>红河综合保税区是全国第三家，全省第一家设立在少数民族自治地区的国家级高新区，也是省委、省人民政府重点打造的主营业务收入超千亿元园区。目前，高新区规划控制面积127平方公里（含东瓜镇、苍岭工业片区），其中：中心建成区21平方公里，工业园区60.27平方公里，形成了以烟草及其配套、冶金化工建材、生物医药、装备制造和绿色食品加工为主的产业体系，以及富民庄甸工业园、赵家湾桃园工业园和苍岭工业园的“一区三园”发展格局。</span><h4>项目情况</h4><span>红河综合保税区合政策的初创期小微企业、创业团队和服务企业团队、创业导师等各种创新创业要素引进孵化器，以规范管理服务为手段，聚集各类创业创新要素，开展创业孵化服务，全力加快企业科技研发及成果转化，加大科技型企业的培育力度，力争把红河综合保税区科技企业孵化器打造成为设施齐全、运行管理规范、服务功能齐全、服务业绩突出、创业创新活跃、示范带动作用强的创新创业孵化载体和平台。</span><h4>招商需求</h4><span>企业注册地在红河综合保税区属地范围内，办公场所应当在孵化器所属场地内；
属新注册企业或申请进入孵化器前企业成立时间不足3年；
企业注册资金一般不超过500万元（对注册资金有特别要求的行业不受此限）；
属迁入的企业，上一年度营业收入一般不超过500万元；
企业从事研究、开发、生产的项目或产品应当符合高新区产业导向；
项目技术来源清晰，无知识产权权属纠纷；市场发展潜力大，预期的经济与社会效益显著</span><h4>产业链</h4><span>企业负责人熟悉本企业产品研究、开发工作，并具有良好的经营管理和市场开拓能力；
有技术开发队伍和技术开发条件，有实施孵化项目的技术能力和后续开发能力；</span><h4>用地情况</h4><span>红河综合保税区是全国第三家，全省第一家设立在少数民族自治地区的国家级高新区，也是省委、省人民政府重点打造的主营业务收入超千亿元园区。目前，高新区规划控制面积127平方公里（含东瓜镇、苍岭工业片区），其中：中心建成区21平方公里，工业园区60.27平方公里，形成了以烟草及其配套、冶金化工建材、生物医药、装备制造和绿色食品加工为主的产业体系，以及富民庄甸工业园、赵家湾桃园工业园和苍岭工业园的“一区三园”发展格局。</span>
      `,
      activeType: 1,
    };
  },
  created() {
    //
    //this.parkDetailData = JSON.parse(sessionStorage.getItem(this.$route.name));
  },
  mounted() {
    let id = this.$route.query.id;
    //this.getetial(id);
  },
  methods: {
    getetial(id) {
      getParkDetail(id).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          let info = ``;
          if (data.investmentPolicy) {
            let str = `<h4>招商政策</h4>`;
            info = info + str + data.investmentPolicy;
          }
          if (data.projectSituation) {
            let str = `<h4>项目情况</h4>`;
            info = info + str + data.projectSituation;
          }
          if (data.investmentDemand) {
            let str = `<h4>招商需求</h4>`;
            info = info + str + data.investmentDemand;
          }
          if (data.industrialChain) {
            let str = `<h4>产业链</h4>`;
            info = info + str + data.industrialChain;
          }
          if (data.talentSituation) {
            let str = `<h4>人才情况</h4>`;
            info = info + str + data.talentSituation;
          }
          if (data.landSituation) {
            let str = `<h4>用地情况</h4>`;
            info = info + str + data.landSituation;
          }
          let infrastructure = "";
          if (data.infrastructureList.length) {
            data.infrastructureList.forEach((item, index) => {
              let obj = this.infrastructureConfigList.find(
                (inItem) => inItem.value == item
              );
              if (index == 0) {
                infrastructure = obj.label;
              } else {
                infrastructure = infrastructure + "，" + obj.label;
              }
            });
          }
          this.$set(data, "infrastructureStr", infrastructure);
          this.info = info;
          this.parkDetailData = data;
          this.setSwiper();
        }
      });
    },
    getFileIconUrl(fileSuffix) {
      let iconUrl;
      switch (fileSuffix) {
        case "pdf":
          iconUrl = require("@/assets/images/common/文件-pdf.png");
          break;
        case "doc":
        case "docx":
          iconUrl = require("@/assets/images/common/文件-word.png");
          break;
        case "zip":
        case "rar":
          iconUrl = require("@/assets/images/common/文件-压缩包.png");
          break;
        case "xls":
        case "xlsx":
          iconUrl = require("@/assets/images/common/excel.png");
          break;
        default:
          iconUrl = require("@/assets/images/common/文件-其它.jpg");
      }
      return iconUrl;
    },
    setSwiper() {
      let swiper = new Swiper(".mySwiper", {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      let swiper2 = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        autoplay: {
          disableOnInteraction: false,
        },
        thumbs: {
          swiper: swiper,
        },
      });
    },
    scrollView(selector) {
      document.querySelector(selector).scrollIntoView();
    },
    previewOrDownFile(url) {
      window.open(this.imgUrl + url);
    },
    //播放视频
    playVideos(file) {
      this.playVideo.show = true;
      this.playVideo.src =
        systemConfig.imgServer + systemConfig.imgApi + file.filePath;
      this.playVideo.title = file.fileTitle || "";
    },
    //查看图片
    handleLook(list, index) {
      this.previewImage.urlList = [];
      list.forEach((item) => {
        this.previewImage.urlList.push(this.imgUrl + item.filePath);
      });
      this.previewImage.index = index;
      this.previewImage.show = true;
    },
  },
};
</script>

<style scoped>
.park-detail {
  width: calc(60% - 20px);
  margin: 0 auto 10px;
  padding: 10px;
  background: white;
}
.park-land {
}
.park-detail-title {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #e0e0e0;
  padding: 4px 2px 4px 0;
}

.park-detail-title-text {
  font-size: 1rem;
  font-weight: 600;
  flex-grow: 1;
}

.park-detail-title-browse-count {
  font-size: 0.75rem;
  color: #8a8a8a;
  align-self: flex-end;
  flex-shrink: 0;
}

.park-detail-base {
  display: flex;
  column-gap: 20px;
}

.park-detail-base-img {
  width: 50%;
  height: 300px;
}

.park-detail-base-content {
  width: 50%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px 10px;
  font-size: 0.85rem;
}

.park-detail-base-content-price {
  grid-column: 1 / -1;
  padding: 8px 4px;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.park-detail-base-content-price-text {
  font-weight: bold;
  font-size: 1rem;
}
.park-detail-base-content-price-span {
  font-size: 0.75rem;
  color: #837a7a;
}
.park-detail-base-content-info {
}

.park-detail-base-content-info-key {
}

.park-detail-base-content-info-value {
}

.info-value-bold {
  font-weight: bold;
}

.info-value-text1 {
  color: #0064fd;
}

.info-value-text2 {
  color: #317dfc;
  font-size: 0.75rem;
}

.info-value-text3 {
  color: #717171;
}

.grid-single-line {
  grid-column: 1 / -1;
}

.park-detail-info {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 3fr 2fr;
  column-gap: 20px;
}

.park-detail-info-content-nav {
  /* display: grid;
  grid-template-columns: repeat(3, 1fr) 2fr; */
  display: flex;
  background-color: #e4e4e4;

  cursor: pointer;
}
.park-detail-info-content-nav-li {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 1rem;
}
.active-li {
  background: #105ab5;
  color: #fff;
}
.park-detail-info-content-nav-item {
}

.park-detail-info-sub-title {
  margin-top: 20px;
  color: #495eb8;
  border-bottom: dashed 1px #e0e0e0;
  padding: 2px;
}
.info-content {
  max-height: 500px;
  overflow: auto;
  margin: 20px 0;
  line-height: 30px;
  white-space: pre-wrap !important;
}

.park-detail-info-content {
}

.park-detail-info-investment-content {
  margin-top: 10px;
}

.park-detail-info-investment-content-table {
  width: 100%;
}

.park-detail-info-investment-content > div {
  border: solid 1px #e0e0e0;
}

.park-detail-info-investment-content-table-c1 {
  background-color: #f1f5ff;
  width: calc(100% / 6);
}

.park-detail-info-investment-content-table-key {
  padding: 4px 8px;
  text-align: center;
}

.park-detail-info-investment-content-table-value {
  color: #909090;
  padding: 4px 8px;
}

.park-detail-info-investment-video {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-video-item-thumbnail {
  width: 120px;
  height: 80px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.park-detail-info-investment-video-item-thumbnail-img {
  cursor: pointer;
  grid-column: 1 / -1;
  grid-row: 1 / -1;
}

.park-detail-info-investment-video-item-thumbnail-action {
  grid-column: 2 / 3;
  grid-row: 2 /3;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  color: white;
}

.park-detail-info-investment-video-item-title {
}

.park-detail-info-investment-image {
  margin: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-image-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-image-item-img {
  width: 120px;
  height: 80px;
  cursor: pointer;
}

.park-detail-info-investment-image-item-title {
}

.park-detail-info-investment-file-li {
  width: 120px;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
}

.park-detail-info-investment-file {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  border: solid 1px #e5e5e5;
}

.park-detail-info-investment-file-item-img {
  width: 80px;
  height: 80px;
  /* padding: 8px 28px; */
  box-sizing: border-box;
  /* filter: grayscale(1); */
  cursor: pointer;
}

table {
  border: solid 1px #d0d0d0;
  border-spacing: 0;
  border-collapse: collapse;
}

.park-detail-table {
  width: 100%;
  margin-top: 10px;
  text-align: center;
  font-size: 0.95rem;
}

.park-detail-table-header {
  background-color: #e6efff;
  color: #105ab5;
  font-weight: 600;
  font-size: 1rem;
  padding: 12px;
}

.park-detail-table-key {
  width: calc(100% / 6);
  padding: 8px;
  color: #000000;
}

.park-detail-table-value {
  width: calc(100% / 6 * 2);
  color: #858585;
  padding: 8px;
}
.park-detail-table-key1 {
  width: calc(100% / 6 * 2);
  color: #000000;
  padding: 4px 8px;
}
.park-detail-table-value1 {
  width: calc(100% / 6);
  color: #858585;
  padding: 4px 8px;
}
.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 1.12rem;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
  height: calc(100% / 7 * 5);
  width: 100%;
}

.mySwiper {
  height: calc(100% / 7 * 2);
  box-sizing: border-box;
  padding: 5px 0;
}

.mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.m-swiper-button {
  --swiper-navigation-size: 14px;
  color: white;
  background-color: #00000073;
  width: 20px;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
}
</style>
